import { Grid, Stack, useMantineTheme } from '@mantine/core'
import React from 'react'
import { SectionPlaceholder } from 'src/components'
import { Images } from 'src/assets'
import { useMediaQuery } from '@mantine/hooks'
import { HeroContent2 } from './components'
import { LazyImage } from 'src/components/common/LazyImage'

export interface HeroProps {}

export const Hero: React.FC<HeroProps> = () => {
  const { HeroImages } = Images
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)

  return (
    <SectionPlaceholder>
      <Grid>
        <Grid.Col
          lg={7}
          md={6}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'center' : 'flex-start' }}
        >
          <HeroContent2 />
        </Grid.Col>
        <Grid.Col lg={5} md={6} ml={isMobile ? -50 : 0}>
          <Stack>
            <LazyImage src={HeroImages.developer} alt="Hero Image" style={{ height: '500px' }} />
          </Stack>
        </Grid.Col>
      </Grid>
    </SectionPlaceholder>
  )
}
